module.exports = __webpack_public_path__ + "images/facebook-434882894ae422c249174bcd6648aa82.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/social/facebook.png
// module id = 15
// module chunks = 0